import { dispatchTwiceGetImpactVenueCo2 } from '@/domain/impact-calculate-venue/actions/utils/dispatch-twice-get-impact-venue-co2';
import { VenueMonthDeclaration } from '@/domain/project-venue-month-declaration/entities/project-venue-month-declaration';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { selectProjectVenuesMonthDeclarationByMonth } from '../project-venue-month-declarations.selectors';
import { getMonthDeclarations } from './get-month-declaration.action';

type Params = {
  projectId: number;
  month: string;
  monthDeclaration: VenueMonthDeclaration;
};

export const submitMonthDeclaration = createAppAsyncThunk(
  'projectVenueMonthDeclaration/submitMonthDeclaration',
  async (
    { projectId, month, monthDeclaration }: Params,
    {
      extra: { projectVenueMonthDeclarationGateway, snackbarGateway },
      getState,
      dispatch,
    },
  ): Promise<void> => {
    const monthDeclarations =
      selectProjectVenuesMonthDeclarationByMonth(month)(getState());
    const submitMode = monthDeclarations ? 'edit' : 'create';
    try {
      await projectVenueMonthDeclarationGateway.submitMonthDeclaration(
        projectId,
        month,
        monthDeclaration,
        submitMode,
      );
      dispatch(getMonthDeclarations({ projectId }));
      dispatchTwiceGetImpactVenueCo2(dispatch, projectId);
      showSnackbarSuccess(snackbarGateway);
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(
    translate('SubmitVenueMonthDeclaration.Message.success'),
  );
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('SubmitVenueMonthDeclaration.Message.error'));
}
